<template>
    <div class="container post-detail my-4" v-if="post != null && post.translate">

        <div class="row g-3">
            <div class="col-lg-8 post-body">
                <h2>{{ post.translate[0].title }}</h2>
                <div class="d-flex justify-content-between align-items-center my-3">
                    <div class="text-muted small">
                        <i class="far fa-calendar me-2"></i>
                        {{ G.dateToStr(post.create_date, 'news_datetime', 'datetime') }}

                        <span class="ms-3">
                            <i class="fas fa-eye me-1 small"></i>{{ post.read_count }}
                        </span>
                    </div>
                    <!-- <router-link :to="{'name': 'post_paging', params: { page: 1, perpage: G.rowsPerPage, category_id: 0, search_text: '' }}"> -->
                    <router-link :to="{'name': 'author_detail', params: { author_name: post.author?.username, author_id: post.author?.id || 0 }}">
                        <div class="text-muted1 small">
                            <!-- <i class="fas fa-user-tie me-2"></i> -->
                            {{ post.author.translate[0].firstname }} {{ post.author.translate[0].lastname }}
                            <img :src="post.author?.image" class="post-author-avatar ms-1" />
                        </div>
                    </router-link>
                </div>
                <img :alt="post.translate[0]?.title" :src="post.image" class="img-fluid rounded-4 object-cover1" style="" />
                <p class="my-3 text-wrap text-break post-content" v-html="post.translate[0].content"></p>
                <!-- <p class="my-3 text-wrap text-break" style="text-align: justify;" v-html="post.translate[0].content"></p> -->
            </div>

            <div class="col-lg-4">
                <HomeSidebar :data="authors" />
            </div>
        </div>

    </div>
</template>


<script>
import { onBeforeMount, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/system_modules/store';

// import { useHead } from '@unhead/vue';

import HomeSidebar from '@/pages/component/HomeSidebar.vue';

import { G, ajax } from '@/_common';

export default {
    title: "post",
    name: "PostP",
    components: {
		HomeSidebar,
	},
	// props: {
	// 	data: {
	// 		type: Object,
    //         default: () => []
	// 	}
	// },
	setup() {
        const store = useStore();
        const route = useRoute();
        // const router = useRouter();

        const TR = ref();
        const post = ref({});
        const authors = ref([]);

        const post_id = route.params && route.params.id ? parseInt(route.params.id) : 0;
        // const def_lang = route.params && route.params.lang ? route.params.lang : "az";

        // const rpath = router.resolve({name: 'post_detail', id: post_id}).path;


        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        onBeforeMount(async () => {
            await ajax({
                url: store.getPostById(post_id),
                success: (e) => {
                    post.value = e.data;
                    // product_filters.value = product.value.product_filters.map(f => f.filter_id);
                    post.value = post.value
                        // 1. Заменяем стандартные youtube.com/embed/ на youtube-nocookie.com/embed/
                        .replace(
                        /src=(["'])(?:https?:)?\/\/(?:www\.)?youtube\.com\/embed\//gi,
                        'src=$1https://www.youtube-nocookie.com/embed/'
                        )
                        // 2. На случай, если в iframe вставили короткую ссылку youtu.be/
                        .replace(
                        /src=(["'])(?:https?:)?\/\/(?:www\.)?youtu\.be\//gi,
                        'src=$1https://www.youtube-nocookie.com/embed/'
                        );
                }
            });

            await ajax({
				url: store.getAuthor() + '?rows=10',
				success: (e) => {
					authors.value = e.data.data;
				}
			});

            // Build product details from it`s filters
            // filters.value.forEach((g) => {
            //     let pdvalue = [];
            //     g.group_filters.forEach(f => {
            //         if( product_filters.value.includes(f.id) ){
            //             pdvalue.push(f.translate[0].name);
            //         }
            //     });
            //     if( pdvalue.length > 0 ){
            //         product_details.value.push({name: g.translate[0].name, data: pdvalue.join(', ')});
            //     }
            // });
        });

        // useHead({
        //     title: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName),
        //     meta: [
        //         // Primary Meta Tags
        //         { name: 'title', content: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName)},
        //         { name: 'description', content: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName)},
        //         { name: 'robots', content: 'index, follow'},
        //         { name: 'viewport', content: 'width=device-width, initial-scale=1'},

        //         // Open Graph / Facebook
        //         { property: 'og:title', content: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName)},
        //         { property: 'og:description', content: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName)},
        //         { property: 'og:url', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { property: 'og:image', itemprop: 'image', content: computed(() => post.value.image ? `${post.value.image}` : `https://${G.main_host}/favicon.png`)},
        //         { property: 'og:image:width', content: '600' },
        //         { property: 'og:image:height', content: '315' },
        //         { property: 'og:image:alt', content: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName) },
        //         { property: 'og:image:type', content: 'image/jpeg' },
        //         { property: 'og:site_name', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { property: 'og:locale', content: computed(() => `${def_lang}-${def_lang.toLocaleUpperCase()}`) },
        //         { property: 'og:type', content: 'article'},

        //         // Open Graph - Article Specific
        //         { property: 'article:published_time', content: computed(() => post.value?.create_date)},
        //         { property: 'article:modified_time', content: computed(() => G.dateToStr(post.value?.update_date, 'datetime', 'datetime_as_pg'))},
        //         { property: 'article:author', content: computed(() => `${post.value.author?.translate[0].firstname} ${post.value.author?.translate[0].lastname}`) },
        //         { property: 'article:section', content: computed(() => `${post.value.category?.translate[0].name}`) },

        //         // Twitter
        //         { name: 'twitter:card', content: 'summary_large_image'},
        //         { name: 'twitter:title', content: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName)},
        //         { name: 'twitter:description', content: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName)},
        //         { name: 'twitter:url', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { name: 'twitter:image', content: computed(() => post.value.image ? `${post.value.image}` : `https://${G.main_host}/favicon.png`)},
        //         { name: 'twitter:site', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { name: 'twitter:creator', content: computed(() => `${post.value.author?.translate[0].firstname} ${post.value.author?.translate[0].lastname}`) },
        //     ],
        // });

        // useSeoMeta({
        //     // Basic SEO
        //     title: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName),
        //     description: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName),

        //     // Open Graph
        //     ogTitle: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName),
        //     ogDescription: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName),
        //     ogImage: computed(() => post.value.image ? `${post.value.image}` : `https://${G.main_host}/favicon.png`),
        //     ogUrl: computed(() => `https://${G.main_host}${rpath}`),
        //     ogType: 'article',
        //     ogSiteName: computed(() => G.projectName),

        //     // Twitter
        //     twitterTitle: computed(() => post.value.translate && post.value.translate[0].title ? `${G.projectName} - ${post.value.translate[0].title}` : G.projectName),
        //     twitterDescription: computed(() => post.value.translate && post.value.translate[0].short ? `${G.projectName} - ${post.value.translate[0].short}` : G.projectName),
        //     twitterImage: computed(() => post.value.image ? `${post.value.image}` : `https://${G.main_host}/favicon.png`),
        //     twitterCard: 'summary_large_image',

        //     // Product specific (structured data will be generated)
        //     articleAuthor: computed(() => `${post.value.author?.translate[0].firstname} ${post.value.author?.translate[0].lastname}`),
        //     articlePublishedTime: computed(() => post.value?.create_date),
        //     articleModifiedTime: computed(() => G.dateToStr(post.value?.update_date, 'datetime', 'datetime_as_pg')),
        // });

        return {
            G,
            TR,
            post,
            authors,
        };
    },
}
</script>

<style lang="scss">
.post-detail{
    .post-body img{
        max-width: 100%;
    }
}
.post-author-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

@media (max-width: 576px){
    .post-content img {
        width: 100% !important;;
        height: auto !important;;
    }
}
</style>
